<template>
  <div class="comment">
    <div class="image">
      <img :src="image" alt="User" />
    </div>
    <div class="body">
      <h4>
        {{ comment.name }}<small> -- {{ date }}</small>
      </h4>
      <p v-html="comment.body"></p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "BlogPostComment",
  props: {
    comment: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    image() {
      return this.comment.image;
    },
    date() {
      return moment(this.comment.created_at).fromNow();
    }
  }
};
</script>
